export const FILTERS = {
    DRAFT: 'DRAFT',
    NOT_PAID: 'NOT_PAID',
    APPROVED: 'APPROVED',
    PAID: 'PAID',
    REVERTED: 'REVERTED',
};

export const FILTER_DISPLAY_MAPPINGS = {
    [FILTERS.DRAFT]: 'Draft',
    [FILTERS.NOT_PAID]: 'Not Paid',
    [FILTERS.APPROVED]: 'Approved',
    [FILTERS.PAID]: 'Paid',
    [FILTERS.REVERTED]: 'Reverted',
};
